<script>
    import { fade, slide, scale } from 'svelte/transition';
    import {flip} from 'svelte/animate';
import { onMount, onDestroy } from 'svelte';
import PollDetails from './PollDetails.svelte';
import PollStore from '../stores/PollStore.js';


export let polls = [];
let unsubscribe;

onMount(() => {
    // subscribe to the polls store and keep the unsubscribe function
    unsubscribe = PollStore.subscribe(data => {
        polls = data;
    });
    // initial data is already in the store; no loadPolls() method exists
    
});

onDestroy(() => {
    if (unsubscribe) unsubscribe();
});

</script>

<div class="poll-list">
{#each polls as poll (poll.id)}
    <div  in:fade={{ duration: 200 }} out:fade|local={{ duration: 200 }} animate:flip={{ duration: 300 }}>
        <PollDetails {poll} />
    </div>
{/each}
</div>

<style>
.poll-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
}
</style>